type Listener = () => void;

const listeners = new Set<Listener>();

/** A chat request answered 401: the session has ended (expired, or the Identity Server session is gone, ADR-0004 §2.6). */
export const reportUnauthorized = () =>
  listeners.forEach(listener => listener());

/** Calls `listener` on every reported 401; returns the unsubscribe. */
export const onUnauthorized = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
